import { Button, Card, Tag, Text } from "@ttc3k/trekker";
import { EnumWidgetType, WidgetManyQuery } from "gql/generated";
import { ArrowRight, Star, StarSolid } from "iconoir-react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import {
  DATE_MONTH_YEAR,
  formatDate,
  getMultilingualString,
} from "shared/utils";
import { Flex } from "styled-system/jsx";

type WidgetCardProps = {
  widget: WidgetManyQuery["widgetMany"][0];
  updatingWidgetId: string;
  onFavoriteClick: (widget: WidgetManyQuery["widgetMany"][0]) => void;
};

export const WidgetCard = ({
  widget,
  onFavoriteClick,
  updatingWidgetId,
}: WidgetCardProps) => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <Card.Surface boxShadow={"none"}>
      <Card.Body backgroundColor={"white"} padding={"300"}>
        <Card.BodyContent alignItems={"center"} gap={"250"}>
          <Flex flexDir={"column"} gap={"50"}>
            <Text visual={"bodySemiBold"} lineClamp={2}>
              {getMultilingualString(widget.name)}
            </Text>
            <Flex>
              <Text visual={"smallMedium"} color={"text.light"}>
                {t("widgets:PAGE.ITEM", { count: widget.itemCount ?? 0 }) +
                  " ・ Updated: " +
                  formatDate(widget.updatedDateISO, DATE_MONTH_YEAR)}
              </Text>
            </Flex>
          </Flex>
          <Flex gap={"250"} alignItems={"center"}>
            <Tag
              visual={
                widget.type === EnumWidgetType.Operator
                  ? "highlight"
                  : "accent.magenta"
              }
              mode="light"
            >
              {t(`widgets:LOOKUPS.TYPE.${widget.type}`)}
            </Tag>
            <Flex gap={"100"} alignItems={"center"}>
              <Button
                Icon={widget.favorited ? StarSolid : Star}
                color={widget.favorited ? "icon.highlight.light" : "icon.light"}
                visual={"primary"}
                mode={"light"}
                size={"sm"}
                onClick={() => onFavoriteClick(widget)}
                isLoading={updatingWidgetId === widget._id}
              />
              <Button
                Icon={ArrowRight}
                visual={"primary"}
                mode={"light"}
                size={"sm"}
                onClick={() => navigate(widget._id)}
              />
            </Flex>
          </Flex>
        </Card.BodyContent>
      </Card.Body>
    </Card.Surface>
  );
};
